import { CSSProperties, useContext } from 'react';

import VohlcRow from './vohlc';
import ExchangeRow from './exchange';

import ThemeContext from '../../../context/theme';

interface Props {
  heads: string[]
  data: any[]
  onRowClick: Function
  vholc?: boolean
}

const ScrollView = (props: Props) => {
  const theme = useContext(ThemeContext);

  let headStyleRight: CSSProperties = { color: "#666", fontSize: 11, textAlign: "right", padding: 12, width: "25%" }
  let headStyleCenter: CSSProperties = { color: "#666", fontSize: 11, textAlign: "center", padding: 12, width: "25%" }

  return (
    <>
      <table
        style={{
          border: `1px solid ${theme.borderColor.default}`,
          backgroundColor: theme.background.default,
          borderCollapse: "collapse",
          width: "100%",
        }}
      >
        <thead  style={{display: "block"}}>
          <tr
            style={{
              border: `1px solid ${theme.borderColor.default}`,
              display:"table",
              tableLayout: "fixed",
              width: "100%"
            }}
          >
            {props.heads.map((head: string, idx: number) => (
              <th style={!idx? headStyleCenter: headStyleRight}>{head}</th>  
            ))}
          </tr>
        </thead>
        <tbody
          style={{
            height: window.innerHeight - 353 ,
            width: "100%",
            display: "block",
            overflow: "scroll"
          }}
        >
          {props.vholc
            ? props.data.map((coin: any, idx: number) => (
              <VohlcRow
                key={`${idx}`}
                coin={coin}
                onClick={props.onRowClick}
              />
            ))
            : (props.data.map((exchange: any, idx: number) => (
                <ExchangeRow
                  key={`${idx}`}
                  exchange={exchange}
                  onClick={props.onRowClick}
                />
              ))
            )
          }
        </tbody>
      </table>
    </>
  );
};

export default ScrollView;
